import {retry} from '@rambler-id/promise'

export const afisha = retry<any>(() => import('./afisha'))
export const afishaRed = retry<any>(() => import('./afisha-red'))
export const championat = retry<any>(() => import('./championat'))
export const classic = retry<any>(() => import('./classic'))
export const eda = retry<any>(() => import('./eda'))
export const lenta = retry<any>(() => import('./lenta'))
export const rambler = retry<any>(() => import('./rambler'))
export const universal = retry<any>(() => import('./universal'))

// map skin names to eagle values
export {
  // map share skins to share.skinName
  afisha as share_afisha,
  championat as share_championat,
  lenta as share_lenta,
  eda as share_eda,
  rambler as share_rambler,
  // map share skins to mediaControl.skinName
  afisha as afisha_html5,
  afisha as afisha_html5_blue,
  afisha as afisha_restaurants,
  championat as championat_html5,
  championat as championat_html5_mma,
  championat as championat_epl,
  eda as eda_html5,
  rambler as rambler_2018,
  rambler as rambler_new_epl,
  lenta as lenta_epl,
  lenta as unity,
  lenta as unity_mma,
  lenta as unity_epl,
  classic as rambler_html5,
  classic as classic_html5,
  classic as html5_classic
}
